import { Form } from '../../atoms/form/Form';
import { Input } from '../../atoms/input/Input';
import { Button } from '../../atoms/button/Button';
import { Validators } from '../../../validators/validate';
import { RegistrationService } from '../../../services/registration';
import { assignmentData } from '../../../global/js/helper/assignmentData';
import { stringToLowerCase } from '../../../global/js/helper/stringToLowerCase';
import { TrackingService } from '../../../services/tracking';
import merge from 'lodash.merge';
import WG from '../../../global/js/wg';

export class TrialForm extends Form {
    constructor(formNode, isBusinessValidator = false) {
        let emailValidators = [Validators.required, Validators.email, Validators.minLength(6)];

        super(
            formNode,
            {
                email: new Input(formNode.querySelector('.trial-form-input'), {
                    validators: emailValidators,
                }),
                button: new Button(formNode.querySelector('.trial-form-button')),
            },
            {
                loading: 'trial-form--loading',
                success: 'trial-form--success',
                serverError: 'trial-form--server-error',
            }
        );

        this.emailValidators = emailValidators;

        if (isBusinessValidator) {
            import(
                /* webpackChunkName: "business-email-validator-chunk" */
                '../../../validators/businessValidate'
            ).then(({ emailBusinessValidator }) => {
                this.emailValidators.push(emailBusinessValidator);
            });
        }
    }

    prepareDataForSend() {
        const pageRegistrationParams = window.wrike.rebrandingRegistrationParams;

        this.dataToSent = {
            plan: assignmentData(this.form.dataset.plan, pageRegistrationParams['plan']),
            addons: assignmentData(this.form.dataset.addons, pageRegistrationParams['addons']),
            promocode: assignmentData(this.form.dataset.promocode, pageRegistrationParams['promo_code']),
            packages: assignmentData(this.form.dataset.packages, pageRegistrationParams['packages']),
            source: assignmentData(this.form.dataset.source, pageRegistrationParams['source']),
            templateId: assignmentData(this.form.dataset.templateId, pageRegistrationParams['template_id']),
            onboarding: assignmentData(this.form.dataset.onboarding, pageRegistrationParams['onboarding']),
        };
    }

    sendRequest() {
        this.prepareDataForSend();

        RegistrationService.registerNewContract(
            this.value.email,
            this.form.dataset.hash,
            this.dataToSent.plan,
            this.dataToSent.addons,
            this.dataToSent.packages,
            this.dataToSent.source,
            this.dataToSent.templateId,
            this.dataToSent.promocode,
            this.dataToSent.onboarding
        )
            .then((response) => {
                this.sendTracking(response.isExisting, response.isCorporate);
                this.responseSuccess();
            })
            .catch(() => {
                this.responseError();
            });
    }

    sendTracking(isUserExist, isCorporate) {
        const cEmail = isCorporate ? 1 : 'null';

        const statSiteData = {
            group: isUserExist ? 'exist_user_form_submit' : 'trial_forms',
            event: isUserExist ? 'exist_trial_form__submit' : 'trial_form__submit',
            path: window.location.pathname,
        };

        const airPrData = {
            event: isUserExist ? 'exist_trial_form__submitted' : 'trial_form__submitted',
        };

        TrackingService.trackEventForm(merge({}, this._prepareTrackingData(isUserExist, cEmail), statSiteData));
        TrackingService.trackAirPr(merge({}, this._prepareTrackingData(isUserExist, cEmail), airPrData));
    }

    _prepareTrackingData(existing_user, c_email) {
        const defaultData = {
            value: {
                existing_user,
                c_email,
                email: this.value.email,
                form: this.form.dataset.hash,
                plan: this.dataToSent.plan || 'BIZ_2021',
            },
        };

        if (this.dataToSent.onboarding) {
            defaultData.value['onboarding'] = this.dataToSent.onboarding;
        }

        if (this.dataToSent.addons) {
            defaultData.value['addons'] = this.dataToSent.addons;
        }

        if (this.dataToSent.packages) {
            defaultData.value['packages'] = this.dataToSent.packages;
        }

        return defaultData;
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/molecules/trial-form/trial-form.js